/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAuthSessionOutput } from "../../entities/models/AuthSessionOutput";
import { z } from "zod/v4";

export const modelsAuthSessionOutputSchema = z.object({
    "access_token": z.optional(z.string()),
"expires_at": z.optional(z.string()),
"message": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsAuthSessionOutput>